import * as React from 'react';

import type {EmailAddressee} from 'nutshell-core/types';

import {EmailLinkedEntities} from 'shells/email-address-links/email-linked-entities';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';

type Props = {
    actor: EmailAddressee;
    verb: string;
    participants?: EmailAddressee[];
};

export const ActorVerbParticipants = (props: Props) => {
    const {actor, verb, participants} = props;

    return (
        <div className='flex'>
            <div>
                <LinkedEntity
                    name={actor.entity ? actor.entity.name : 'Unknown'}
                    type='users'
                    shouldClientRoute={true}
                    htmlUrl={actor.entity ? actor.entity.htmlUrl : ''}
                    isLinkable={true}
                />
            </div>
            <div>
                &nbsp;
                {verb}
                &nbsp;
            </div>
            {participants ? (
                <div>
                    {/* @ts-expect-error */}
                    <EmailLinkedEntities
                        emailAddressees={participants}
                        showAll={false}
                        numDisplayed={3}
                        shouldFlex={true}
                        isHoverable={true}
                    />
                </div>
            ) : null}
        </div>
    );
};
